import {
  GET_POPUP_SETUP,
  API_ERROR,
  ADD_POPUP_SETUP,
  GET_POPUP_SETUP_SUCCESS,
  ADD_POPUP_SETUP_SUCCESS,
} from "store/popup/actionTypes"

export const getPopupSetup = params => {
  return {
    type: GET_POPUP_SETUP,
    payload: { params },
  }
}

export const addPopupSetup = values => {
  return {
    type: ADD_POPUP_SETUP,
    payload: { values },
  }
}

export const addPopupSetupSuccess = response => {
  return {
    type: ADD_POPUP_SETUP_SUCCESS,
    payload: response,
  }
}

export const getPopupSetupSuccess = values => {
  return {
    type: GET_POPUP_SETUP_SUCCESS,
    payload: values,
  }
}
